import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from './state';
import { Loader } from './components/loader/Loader';
import { Application } from './Application';

export const ApplicationWrapper = observer(() => {
  const { applicationStore } = useStore();

  useEffect(() => {
    applicationStore.setLoading(false);
  }, [applicationStore]);

  if (applicationStore.isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200 }}>
        <Loader />
      </div>
    );
  }

  return <Application />;
});
